import styled from 'styled-components';
import {
  color,
  fontFamily,
  fontSize,
  fontWeight,
  radius,
  screen,
  spacing,
} from '../../../theme';

export const StyledHeroCompany = styled.section`
  grid-area: company;
  display: none;
  flex-direction: column;
  background-color: ${color('white')};
  color: ${color('text_default')};
  border-radius: ${radius('md')};

  @media (min-width: ${screen('md')}) {
    display: flex;
  }
`;

export const StyledHeroCompanyHeader = styled.header`
  display: flex;
  justify-content: center;
  padding: ${spacing('md')};
`;

export const StyledHeroCompanyLogo = styled.img`
  display: block;
  max-height: 4rem;
  object-fit: contain;
`;

export const StyledHeroCompanyInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  line-height: 1.2;
  border-left: 1px solid ${color('midnight_200')};
  padding-left: ${spacing('md')};
  margin-left: ${spacing('md')};

  a {
    font-family: ${fontFamily('serif')};
    font-size: ${fontSize('lg')};
    font-weight: ${fontWeight('bold')};
  }
  span {
    font-size: ${fontSize('xs')};
    font-weight: ${fontWeight('medium')};
    text-transform: uppercase;
  }
`;

export const StyledHeroCompanyPhoto = styled.div`
  img {
    display: block;
    max-width: none;
    width: 100%;
  }
`;

export const StyledHeroCompanyFooter = styled.footer`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${spacing('md')};
`;

export const StyledHeroCompanyManagement = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  span {
    color: ${color('text_subtle')};
    font-size: ${fontSize('xs')};
    font-weight: ${fontWeight('medium')};
    line-height: 1.33;
  }
  img {
    display: block;
    max-height: 1.25rem;
  }
`;

export const StyledHeroCompanyScout = styled.div`
  display: flex;
  align-items: center;

  .scout-avatar {
    margin-right: ${spacing('xs')};
  }
`;

export const StyledHeroCompanyScoutInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  span {
    color: ${color('text_subtle')};
    font-size: ${fontSize('xs')};
    font-weight: ${fontWeight('bold')};
    line-height: 1.14;
    text-transform: uppercase;
  }
  a {
    font-size: ${fontSize('sm')};
    font-weight: ${fontWeight('bold')};
    line-height: 1.14;
  }
`;
